import { OperatorMasterDto } from '../_models/operatorMaster.models';
import axios, { AxiosResponse } from 'axios';

const getOperatorMasters = (plantCode:string, factoryCode:string, operatorName:string): Promise<AxiosResponse<OperatorMasterDto[]>> => {
    return axios.get('/api/v1/operatornmasters', {
        params: {plantCode : plantCode, factoryCode: factoryCode, operatorName:operatorName}
    });
}

export const operatorMasterService = {
    getOperatorMasters
}
